// GoodDay presale integration
// Manages selling_plan input and presale UI (badge, buyer promise, CTA text) on variant change.
// Date source priority: selling_plan options["Delivery"].value → variant metafield buyerPromise
(function () {
  'use strict';

  function getDeliveryDate(variantData) {
    if (!variantData) return null;
    var options = variantData.sellingPlanOptions;
    if (Array.isArray(options)) {
      for (var i = 0; i < options.length; i++) {
        if (options[i].name === 'Delivery' && options[i].value) {
          return options[i].value;
        }
      }
    }
    return variantData.buyerPromise || null;
  }

  function initPresaleForm(dataScript) {
    var data;
    try {
      data = JSON.parse(dataScript.textContent);
    } catch (e) {
      console.warn('[GoodDay] JSON parse error in data-goodday-json:', e);
      return;
    }

    var formWrapper = dataScript.closest('product-form');
    if (!formWrapper) return;

    var form = document.getElementById(data.formId);
    if (!form) return;

    var sellingPlanInput = form.querySelector('[data-goodday-selling-plan]');
    var preorderInput    = form.querySelector('[data-goodday-preorder]');
    var badgeEl          = formWrapper.querySelector('[data-goodday-presale-badge]');
    var promiseEl        = formWrapper.querySelector('[data-goodday-buyer-promise]');
    var promiseText      = promiseEl ? promiseEl.querySelector('[data-goodday-promise-text]') : null;
    var addToCartText    = form.querySelector('[data-add-to-cart-text]');

    var variantData      = data.variants || {};
    var preOrderNowText  = data.preOrderNowText  || 'Pre-order Now';
    var addToCartNormal  = data.addToCartText    || 'Add to Cart';
    var shipsByText      = data.shipsByText      || 'Ships by';
    var saleTypeKey      = data.saleTypeKey      || 'Sale type';
    var preOrderValue    = data.preOrderValue    || 'Pre-order';

    function updatePresaleState(variant) {
      if (!variant) return;

      var allocations   = variant.selling_plan_allocations;
      var isAvailable   = !!variant.available;
      var variantId     = String(variant.id);
      // Only GoodDay presale plans carry a "Delivery" option or a buyer promise metafield.
      // Regular subscription selling plans have neither, so getDeliveryDate returns null for them.
      var deliveryDate  = getDeliveryDate(variantData[variantId]);
      var hasPresalePlan = Array.isArray(allocations) && allocations.length > 0 && deliveryDate !== null;

      if (hasPresalePlan) {
        var planId = allocations[0].selling_plan_id;

        if (sellingPlanInput) {
          sellingPlanInput.setAttribute('name', 'selling_plan');
          sellingPlanInput.value = planId;
        }

        if (preorderInput) {
          preorderInput.setAttribute('name', 'properties[' + saleTypeKey + ']');
          preorderInput.value = preOrderValue;
        }

        if (promiseText) {
          promiseText.textContent = deliveryDate || '';
        }
        if (promiseEl) promiseEl.classList.remove('hide');
        if (badgeEl)   badgeEl.classList.remove('hide');

        if (addToCartText && isAvailable) {
          addToCartText.textContent = preOrderNowText;
        }
      } else {
        if (sellingPlanInput) {
          sellingPlanInput.removeAttribute('name');
          sellingPlanInput.value = '';
        }

        if (preorderInput) {
          preorderInput.removeAttribute('name');
          preorderInput.value = '';
        }

        if (promiseEl) promiseEl.classList.add('hide');
        if (badgeEl)   badgeEl.classList.add('hide');

        if (addToCartText && addToCartText.textContent === preOrderNowText) {
          addToCartText.textContent = addToCartNormal;
        }
      }
    }

    formWrapper.addEventListener('theme:variant:change', function (event) {
      var variant = event.detail && event.detail.variant;
      updatePresaleState(variant);
    });

    // Initial state from embedded product JSON
    var productJsonScript = form.querySelector('[data-product-json]');
    if (productJsonScript) {
      try {
        var productData = JSON.parse(productJsonScript.textContent);
        var idInput = form.querySelector('[data-productid]');
        if (idInput && productData.variants) {
          var currentId = parseInt(idInput.value, 10);
          var currentVariant = productData.variants.find(function (v) {
            return v.id === currentId;
          });
          if (currentVariant) updatePresaleState(currentVariant);
        }
      } catch (e) {
        console.warn('[GoodDay] Could not parse product JSON:', e);
      }
    }
  }

  function init() {
    document.querySelectorAll('[data-goodday-json]').forEach(initPresaleForm);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
